import { API, Storage } from 'aws-amplify';

export const create = async (company) => API.put('eventmanagerAdminApi', `/companies`, {body: company});

export const read = async () => API.get('eventmanagerAdminApi', '/companies', {});

export const readOne = async (id) => API.get('eventmanagerAdminApi', `/companies/${id}`, {});

export const update = async (company) => API.post('eventmanagerAdminApi', `/companies`, {body: company});

export const del = async (id) => API.del('eventmanagerAdminApi', `/companies/${id}`, {});

// @ts-ignore
export const uploadImage = (name, image) => {
  // TODO: check if file exists already
  return Storage.put(name, image, { level: 'public', contentType: 'image/png' });
};
